// URLs dos vídeos explicativos por audiência.
// Quando os vídeos estiverem prontos (YouTube, Vimeo, Cloudinary, ou MP4 self-hosted),
// substitua os valores abaixo. O componente <VideoExplicativo> renderiza placeholder
// até a URL estar populada.
//
// Formatos aceitos:
// - YouTube embed: 'https://www.youtube.com/embed/VIDEO_ID'
// - Vimeo embed:   'https://player.vimeo.com/video/VIDEO_ID'
// - MP4 direto:    'https://cdn.../paciente.mp4'

export type AudiencaVideo = 'paciente' | 'medico' | 'psicologo'

export const VIDEOS: Record<AudiencaVideo, { url: string; titulo: string; duracao: string }> = {
  paciente: {
    url: '',  // TODO: subir vídeo de 60s
    titulo: 'O que é o Anamis?',
    duracao: '60s',
  },
  medico: {
    url: '',  // TODO: subir vídeo de 75s
    titulo: 'Anamis pra médicos: devolva 15 minutos por consulta',
    duracao: '75s',
  },
  psicologo: {
    url: '',  // TODO: subir vídeo de 75s
    titulo: 'Anamis pra psicólogos: continuidade entre as sessões',
    duracao: '75s',
  },
}

export function temVideo(audiencia: AudiencaVideo): boolean {
  return !!VIDEOS[audiencia].url && VIDEOS[audiencia].url.length > 8
}
